// extracted by mini-css-extract-plugin
export default {"container":"Paginacao_container__wRWRZ"};